import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * MoreToolsQuickNavGrid — the 2-column grid of shortcut cards (search,
 * support, tasks, ...) shown in the phone drawer. Each item is either a
 * custom action (button) or a plain navigation link.
 */
const MoreToolsQuickNavGrid = ({ isDark, items, onNavigate }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div
        className={`text-xs font-semibold uppercase tracking-wider mb-2.5 px-1 ${
          isDark ? "text-white/50" : "text-gray-400"
        }`}
      >
        {t("shortcuts") || "الوصول السريع"}
      </div>
      <div className="grid grid-cols-2 gap-2.5">
        {items.map((item) =>
          item.isCustomAction ? (
            <button
              key={item.id}
              type="button"
              onClick={item.onClick}
              className={`p-3 rounded-xl flex items-center gap-3 border transition-all text-start cursor-pointer hover:scale-[1.01] active:scale-[0.99] ${
                isDark
                  ? "bg-white/[0.04] border-white/[0.08] text-white hover:bg-white/[0.08]"
                  : "bg-[#F9FAFB] border-gray-100 text-heading hover:bg-gray-100/80"
              }`}
            >
              <div
                className={`w-9 h-9 rounded-lg ${item.bg} ${item.color} flex items-center justify-center shrink-0`}
              >
                <FontAwesomeIcon icon={item.icon} className="text-sm" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-xs font-semibold truncate">
                  {item.title}
                </div>
              </div>
            </button>
          ) : (
            <Link
              key={item.id}
              to={item.to}
              onClick={onNavigate}
              className={`p-3 rounded-xl flex items-center gap-3 border transition-all hover:scale-[1.01] active:scale-[0.99] ${
                isDark
                  ? "bg-white/[0.04] border-white/[0.08] text-white hover:bg-white/[0.08]"
                  : "bg-[#F9FAFB] border-gray-100 text-heading hover:bg-gray-100/80"
              }`}
            >
              <div
                className={`w-9 h-9 rounded-lg ${item.bg} ${item.color} flex items-center justify-center shrink-0`}
              >
                <FontAwesomeIcon icon={item.icon} className="text-sm" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-xs font-semibold truncate">
                  {item.title}
                </div>
              </div>
              {item.count > 0 && (
                <span className="min-w-[20px] h-5 px-1.5 rounded-full bg-danger text-white text-[11px] font-bold flex items-center justify-center shrink-0">
                  {item.count}
                </span>
              )}
            </Link>
          )
        )}
      </div>
    </div>
  );
};

export default MoreToolsQuickNavGrid;
